import React from "react";
import { useMarketingPagesTracking } from "../hooks/marketingPagesTracking";
import { homepageData } from "../utils/homepage_data/homepage_data";
import { HomepagePageLayout } from "../pagelayouts/homepage";

const Homepage = () => {
    useMarketingPagesTracking();

    return (
        <HomepagePageLayout data={{ ...homepageData, faq: [] }} usersList={{ users: [] }} canonical={process.env.NEXT_PUBLIC_FRONTEND_URL || ""} />
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Homepage;
